/* eslint-disable jsx-a11y/iframe-has-title */
import {InteractionLayer, ShimLayer} from '@volkswagen-onehub/components-core';
import React, {useCallback, useEffect, useRef} from 'react';
import {CSSTransition, TransitionGroup} from 'react-transition-group';
import CloseButtonSVG from '../CloseButtonSVG';
import SpaceLike from '../Space';
import TypographyBody from '../Typography/TypographyBody';
import TypographyHeading from '../Typography/TypographyHeading';
import './style.css';
import useMediaQuery from '../../hooks/useMediaQuery';

interface SidebarProps {
  active: boolean;
  onClose: () => void;
  title?: string;
  subTitle?: string;
  children?: React.ReactNode;
}

const Sidebar = ({
  active,
  onClose,
  title,
  subTitle,
  children,
}: SidebarProps) => {
  const sidebarRef = useRef<HTMLDivElement>(null);
  const {isMobile} = useMediaQuery();

  const handleClickOutside = useCallback(
    (event: MouseEvent) => {
      if (
        sidebarRef.current &&
        !sidebarRef.current.contains(event.target as Node)
      ) {
        onClose();
      }
    },
    [onClose],
  );

  useEffect(() => {
    if (active) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [active, handleClickOutside]);

  return (
    <TransitionGroup>
      <div
        style={{
          position: 'relative',
          zIndex: 999,
          paddingTop: 150,
        }}
      >
        {active && <ShimLayer key="shim" />}
        <div ref={sidebarRef}>
          <CSSTransition
            in={active}
            timeout={300}
            classNames="slide"
            unmountOnExit
          >
            <InteractionLayer size={'E'} active>
              <CloseButtonSVG
                color="#000"
                style={{position: 'absolute', top: 80, right: 50}}
                onClick={onClose}
              />
              <SpaceLike
                customStyles={{
                  height: '100vh',
                  display: 'flex',
                }}
                direction="vertical"
              >
                {(title || subTitle) && (
                  <SpaceLike
                    direction="vertical"
                    size={18}
                    customStyles={{marginBottom: 40, paddingTop: 100}}
                  >
                    <TypographyHeading
                      tag="h3"
                      color="black"
                      size="medium"
                      textAlign="center"
                      style={{fontSize: isMobile ? 26 : 32}}
                    >
                      {title}
                    </TypographyHeading>
                    <TypographyBody
                      size="small"
                      color="black"
                      textAlign="center"
                    >
                      {subTitle}
                    </TypographyBody>
                  </SpaceLike>
                )}
                {children}
              </SpaceLike>
            </InteractionLayer>
          </CSSTransition>
        </div>
      </div>
    </TransitionGroup>
  );
};

export default Sidebar;
